import React from 'react';
import { Check, X } from 'lucide-react';
import { IS_MAGIC_TEAM } from '../../lib/brand';

const formatDate = (iso) =>
  new Date(iso).toLocaleString('it-IT', {
    day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
  });

const NotificationItem = ({ notif, onMarkRead, onDelete }) => {
  const isTargeted = notif.visibility === 'private' && (notif.recipient_user_ids?.length > 0);

  return (
  <div
    className={`p-4 border-b border-zinc-100 hover:bg-zinc-50 transition-colors cursor-pointer ${notif.read ? 'opacity-60' : ''}`}
    onClick={() => onMarkRead(notif.id)}
    data-testid={`notif-item-${notif.id}`}
  >
    <div className="flex items-start gap-3">
      {!notif.read && <span className="w-2 h-2 bg-[#D4AF37] rounded-full mt-2 flex-shrink-0" />}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 flex-wrap">
          {!IS_MAGIC_TEAM && notif.is_banner && (
            <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-[#D4AF37]/10 text-[#B8941F]">Banner</span>
          )}
          {isTargeted && (
            <span className="px-1.5 py-0.5 rounded text-[10px] font-semibold bg-zinc-100 text-zinc-500">
              Solo {notif.recipient_user_ids.length === 1 ? '1 utente' : `${notif.recipient_user_ids.length} utenti`}
            </span>
          )}
        </div>
        <p className="font-medium text-zinc-900 text-sm">{notif.title}</p>
        <p className="text-zinc-600 text-xs mt-1 line-clamp-2">{notif.body}</p>
        <p className="text-zinc-400 text-xs mt-2">{formatDate(notif.created_at)}</p>
      </div>
      <div className="flex flex-col items-center gap-1 flex-shrink-0 mt-0.5">
        {onDelete && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(notif.id);
            }}
            className="p-1 rounded-md text-zinc-400 hover:text-red-600 hover:bg-red-50 transition-colors"
            aria-label="Elimina notifica"
            data-testid={`notif-delete-${notif.id}`}
          >
            <X className="w-4 h-4" />
          </button>
        )}
        {notif.read && <Check className="w-4 h-4 text-zinc-300" />}
      </div>
    </div>
  </div>
  );
};

export default NotificationItem;
